import React from "react";
import Logo from "./Logo";
import { homeImages } from "../constants/homeImages";
import "./Hero.css";

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToServices = () => {
    const element = document.getElementById("services");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="hero banner">
      <div className="hero-media" aria-hidden="true">
        <img
          src={homeImages.heroBannerFull}
          alt="Panthi Events — wedding and corporate event management in Ahmedabad, Gujarat, India"
          className="hero-media-img"
          width={1920}
          height={1080}
          decoding="async"
          fetchPriority="high"
        />
      </div>
      <div className="hero-media-scrim" aria-hidden="true" />
      <div className="banner-overlay"></div>
      <div className="hero-container">
        <div className="hero-content banner-content">
          <div className="banner-logo-wrap">
            <Logo size="large" />
          </div>
          <h1 className="hero-title">PANTHI EVENTS</h1>
          <p className="hero-tagline">YOUR EVENT, OUR PASSION</p>
          <p className="hero-description">
            Creating unforgettable moments with elegance, creativity, and
            attention to detail. From intimate gatherings to grand celebrations,
            we bring your vision to life.
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={scrollToContact}>
              Get In Touch
            </button>
            <button className="btn btn-secondary" onClick={scrollToServices}>
              Our Services
            </button>
          </div>
        </div>
        <div className="hero-decoration">
          <div className="floating-shape shape-1"></div>
          <div className="floating-shape shape-2"></div>
          <div className="floating-shape shape-3"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
